var JSZip = require( "jszip" );
var DOMParser = require( "xmldom" ).DOMParser;
var XMLSerializer = require( "xmldom" ).XMLSerializer;

var Style = require( "./merge-styles" );
var Media = require( "./merge-media" );
var RelContentType = require( "./merge-relations-and-content-type" );
var bulletsNumbering = require( "./merge-bullets-numberings" );

function DocxMerger( options, files ) {
	this._body = [];
	this._header = [];
	this._footer = [];
	this._Basestyle = options.style || "source";
	this._style = [];
	this._numbering = [];
	this._pageBreak = typeof options.pageBreak !== "undefined" ? !!options.pageBreak : true;
	this._columnBreak = typeof options.columnBreak !== "undefined" ? !!options.columnBreak : false;
	this._lineBreak = typeof options.lineBreak !== "undefined" ? !!options.lineBreak : false;
	this._sectPr = typeof options.sectPr !== "undefined" ? !!options.sectPr : false;
	this._title = typeof options.title !== "undefined" ? options.title : "タイトル";
	this._setNum = typeof options.setNum !== "undefined" ? options.setNum : [];
	this._setNumCnt = typeof options.setNumCnt !== "undefined" ? options.setNumCnt : 1;
	this._pageNum = typeof options.pageNum !== "undefined" ? options.pageNum : "";
	this._param = typeof options.param !== "undefined" ? options.param : [];

	this._files = [];
	var self = this;
	( files || [] ).forEach( function ( file ) {
		self._files.push(
			new JSZip( file, {
				base64: true
			} )
		);
	} );
	this._contentTypes = {};

	this._media = {};
	this._rel = {};
	this._fileCnt = 0;
	this._mediaFiles = [];
	this._mediaCnt = 1;

	this._builder = this._body;

	this.insertPageBreak = function () {
		var pb = '<w:p> \
					<w:r> \
						<w:br w:type="page"/> \
					</w:r> \
				  </w:p>';

		this._builder.push( pb );
	};

	this.insertColumnBreak = function () {
		var cb = '<w:p> \
					<w:r> \
						<w:br w:type="column"/> \
					</w:r> \
				</w:p>';

		this._builder.push( cb );
	};
	this.insertLineBreak = function () {
		var lb = '<w:p> \
					<w:r> \
						<w:rpr> \
							<w:rpr> \
								<w:rFonts w:hint="eastAsia"/> \
							</w:rpr> \
						</w:rpr> \
					</w:r> \
				</w:p>';

		this._builder.push( lb );
	};

	this.insertSectPr = function ( xml ) {
		this._builder.push( xml );
	};

	this.insertRaw = function ( xml ) {
		this._builder.push( xml );
	};

	this.mergeBody = function ( files ) {
		var self = this;
		var trMedia = {};
		var mCnt;
		self._builder = self._body;

		RelContentType.mergeContentTypes( files, self._contentTypes );
		mCnt = Media.prepareMediaFiles( files, self._media, self._fileCnt, self._mediaCnt, trMedia );
		self._mediaCnt = mCnt;
		RelContentType.mergeRelations( files, self._rel );

		bulletsNumbering.prepareNumbering( files, self._fileCnt );
		bulletsNumbering.mergeNumbering( files, self._numbering );

		Style.prepareStyles( files, self._style, self._fileCnt );
		Style.mergeStyles( files, self._style );

		//console.log( trMedia, this._files, this._fileCnt );
		Media.collectMediaFiles( self._mediaFiles, trMedia, self._files, self._fileCnt );

		self._fileCnt += self._files.length;


		files.forEach( function ( zip, index ) {
			//var zip = new JSZip(file);
			var xml = zip.file( "word/document.xml" ).asText();
			var sectPr = "";
			if ( self._sectPr ) {
				// セクション区切り
				sectPr = xml.substring(
					xml.lastIndexOf( "<w:sectPr" ),
					xml.lastIndexOf( "</w:sectPr>" ) + 11
				);
				sectPr = "<w:p><w:pPr>" + sectPr + "</w:pPr></w:p>";
			}
			xml = xml.substring( xml.indexOf( "<w:body>" ) + 8 );
			xml = xml.substring( 0, xml.indexOf( "</w:body>" ) );
			xml = xml.substring( 0, xml.lastIndexOf( "<w:sectPr" ) );
			if ( sectPr ) {
				xml += sectPr;
			}

			//------------------------------------------------------------------------
			// 置換え諸々
			// タイトル
			xml = xml.replace( "ý", self._title );
			// ページ番号
			if ( self._pageNum === "" ) {
				xml = xml.replace( "ø", "" );
			} else {
				xml = xml.replace( "ø", "— " + ( self._pageNum + index ) + " —" );
				//console.log( self._pageNum + index );
			}
			// 問題番号
			if ( typeof self._setNum[ index ] !== "undefined" ) {
				if ( self._setNum[ index ] != "" ) {
					for ( var numCnt = 0; numCnt < self._setNumCnt; numCnt++ ) {
						xml = xml.replace( "þ", self._setNum[ index ] + numCnt );
					}
				}
			}
			// 点数などその他
			for ( var pCnt = 0; pCnt < self._param.length; pCnt++ ) {
				if( "type" in self._param[ pCnt ]? self._param[ pCnt ].type === "regExp" : false ){
					var trRegExp = new RegExp( self._param[ pCnt ].before, "g" );
					xml = xml.replace( trRegExp, self._param[ pCnt ].after );
				}else{
					xml = xml.replace( self._param[ pCnt ].before, self._param[ pCnt ].after );
					//console.log( xml );
				}
			}
			//------------------------------------------------------------------------
			self.insertRaw( xml );

			// 改行
			if ( self._lineBreak ) {
				self.insertLineBreak()
				//var bfXml = xml.substring( 0, xml.lastIndexOf( "</w:p>" ) );
				//var afXml = xml.substring( xml.lastIndexOf( "</w:p>" ) );
				//xml = bfXml + "<w:p><w:r><w:rpr><w:rpr><w:rFonts w:hint=\"eastAsia\"/></w:rpr></w:rpr></w:r></w:p>" + afXml;
			}

			// 段落区切り
			if ( self._columnBreak ) {
				self.insertColumnBreak();
			}

			// 改ページ
			if ( self._pageBreak ) {
				self.insertPageBreak();
			}

		} );
	};

	this.save = function ( type, callback ) {
		//var zip = this._files[0];
		var zip = this._files[ this._files.length - 1 ];

		var coreXml = zip.file( "docProps/core.xml" ).asText();
		var xml = zip.file( "word/document.xml" ).asText();
		var startIndex = xml.indexOf( "<w:body>" ) + 8;
		var endIndex = xml.lastIndexOf( "<w:sectPr" );

		xml = xml.replace( xml.slice( startIndex, endIndex ), this._body.join( "" ) );

		// ユーザー情報の変更
		coreXml = coreXml.replace(
			/<dc:creator>(.*)<\/dc:creator>/i,
			"<dc:creator>正進社</dc:creator>"
		);
		coreXml = coreXml.replace(
			/<cp:lastModifiedBy>(.*)<\/cp:lastModifiedBy>/i,
			"<cp:lastModifiedBy>正進社</cp:lastModifiedBy>"
		);
		coreXml = coreXml.replace(
			/<cp:revision>(.*)<\/cp:revision>/i,
			"<cp:revision>1</cp:revision>"
		);

		RelContentType.generateContentTypes( zip, this._contentTypes );
		Media.copyMediaFiles( zip, this._media, this._mediaFiles );
		RelContentType.generateRelations( zip, this._rel );
		bulletsNumbering.generateNumbering( zip, this._numbering );
		Style.generateStyles( zip, this._style );

		// ルビ用の w:val を調整
/*		xml = xml.replace( /w:val="\d+(?:\.\d+)?_\d+(?:\.\d+)?"/g, function ( result ) {
			return result.split( "_" ).shift() + "\"";
		} );
*/
		xml = xml.replace( /(w:hps|w:hpsRaise|w:hpsBaseText|w:sz|w:szCs|w:gridSpan) w:val="\d+(?:\.\d+)?_\d+(?:\.\d+)?"/g, function ( result ) {
			return result.split( "_" ).shift() + "\"";
		} );

		zip.file( "word/document.xml", xml );
		zip.file( "docProps/core.xml", coreXml );

		callback(
			zip.generate( {
				type: type,
				compression: "DEFLATE",
				compressionOptions: {
					level: 4
				}
			} )
		);
	};

	// 再開(ファイルの追加)
	this.addDocx = function ( addOpt, addFile ) {
		var self = this;
		self._lineBreak = typeof addOpt.lineBreak !== "undefined" ? !!addOpt.lineBreak : false;
		self._pageBreak = typeof addOpt.pageBreak !== "undefined" ? !!addOpt.pageBreak : true;
		self._columnBreak = typeof addOpt.columnBreak !== "undefined" ? !!addOpt.columnBreak : false;
		self._sectPr = typeof addOpt.sectPr !== "undefined" ? !!addOpt.sectPr : false;
		self._title = typeof addOpt.title !== "undefined" ? addOpt.title : "タイトル";
		self._setNum = typeof addOpt.setNum !== "undefined" ? addOpt.setNum : [];
		self._setNumCnt = typeof addOpt.setNumCnt !== "undefined" ? addOpt.setNumCnt : 1;
		self._pageNum = typeof addOpt.pageNum !== "undefined" ? addOpt.pageNum : "";
		self._param = typeof addOpt.param !== "undefined" ? addOpt.param : [];
		self._files = [];

		( addFile || [] ).forEach( function ( file ) {
			self._files.push(
				new JSZip( file, {
					base64: true
				} )
			);
		} );

		if ( self._files.length > 0 ) {
			self.mergeBody( self._files );
		}
	};

	if ( this._files.length > 0 ) {
		this.mergeBody( this._files );
	}

	this.setMerge = function () {
		this.mergeBody( this._files );
		callback( "end" );
	};
}

module.exports = DocxMerger;